export default "__VITE_ASSET__1355092b__"